export default __webpack_public_path__ + "static/media/CaviarDreams.174b0a13.ttf";